module.exports = __webpack_public_path__ + "img/date_range.20edcc86.png";